@use '../../styles/tokens' as *;

.error {
  align-items: center;
  background-color: $colorOffWhite;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  width: 100vw;

  article {
    text-align: center;
  }

  h1,
  h2,
  p {
    color: $colorPrimary;
  }

  a {
    color: $colorPrimary;
    text-decoration: underline;
  }
}

.notFoundImage {
  animation: searchMovement 5000ms ease infinite;
  width: 20rem;
}

@keyframes searchMovement {
  0% {
    transform: translate(0);
  }
  25% {
    transform: rotate(12deg);
  }
  50% {
    transform: translate(30deg);
  }
  75% {
    transform: translate(-15deg);
  }
  100% {
    transform: translate(0);
  }
}

.networkRestricted {
  max-width: 48rem;
  padding: 0 1.6rem;

  p {
    margin-top: 1.6rem;
  }
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 2.4rem;
  justify-content: center;
  margin-top: 2.4rem;

  button {
    background: none;
    border: none;
    color: $colorPrimary;
    cursor: pointer;
    font: inherit;
    padding: 0;
    text-decoration: underline;
  }
}
